module.exports = __webpack_public_path__ + "img/7-preview.6f15d38c.png";